import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  className?: string;
  size?: IconSize;
}

const OrderCollection = (props: IconProps): JSX.Element => (
  <SvgIcon {...props}>
    <path
      d="M8.4 9.7V5.1a3.6 3.6 0 017.2 0v4.6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M20 9v13H4V9h16zm2-2H2v17h20V7z" fill="currentColor" />
  </SvgIcon>
);

export default OrderCollection;
